import { memo } from 'react';
import CartIcon from '@tradera/blueprint/theme/icons2/cart.svg?jsx';
import { useUrlLocalizer } from 'tradera/lang/translate';
import { HeaderBadge } from 'tradera/components/site-header/header-badge';
import { Button } from 'tradera/components/atoms/button/button';

type CartLinkProps = { cartItemCount: number };

const CartLink = ({ cartItemCount }: CartLinkProps) => {
    const { toLocalizedUrl } = useUrlLocalizer();
    const cartUrl = toLocalizedUrl('/shopping/cart');
    return (
        <Button
            className="slim-header__button"
            rel="nofollow"
            data-ga-category="Top navigation"
            data-ga-action="Cart"
            data-ga-label="Link - Cart with items from NavBar"
            data-nav-wishlist
            href={cartUrl}
            theme="text">
            <HeaderBadge count={cartItemCount} />
            <CartIcon className="icon icon-md" />
        </Button>
    );
};

export default memo(CartLink);
